import {CallBackEndService} from '../call-back-end.service';
import {Component, OnInit} from '@angular/core';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';

import {Angular2CsvModule} from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
import {timerComponent} from "../cheque-book-request/timerComponent";
@Component({
  selector: 'app-loan-account',
  templateUrl: './loan-account.component.html',
  styleUrls: ['./loan-account.component.css'],
  providers: [
    {provide: 'Window', useValue: window}
  ]
})
export class LoanAccountComponent implements OnInit {
  message: string;
  isShow: string = 'page1';
  loanAccounts: any = [];
  loanAcct: any;
  loanacctNo: string = '';
  showLoanAcctBalanceButtonName : string ='Hide';
  showLoanAmount : string ='Hide';
  moduleType : string ='';
  fullName : string ='' ;
  clrBalanceStr : string ='';
  loanAcctInfo() {
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.loanacctNo);
    request.param2 = this.loanacctNo;
   
  
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200') {
        //this.transactionListRespTD=IbResponse;
        this.loanAcct = data.param5;

        this.moduleType = data.param5.moduleType;
        this.fullName = data.param5.fullName;
        this.clrBalanceStr = data.param5.clrBalanceStr;
        this.isShow = 'page2';
        this.showLoanAmount ='Hide';
      } else if (data !== null && data.status === 'S200') {
        //this.error = response.statusDescription;
      }else{
        //alert(data);
      }
    });
    
  }
  constructor(private webService: CallBackEndService,
              private timetStart : timerComponent
  ) {
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.loanacctNo=this.loanAccounts[0];
    request.param1 = getHexAscii('', this.loanacctNo);
    request.param2 = this.loanacctNo;
     if(this.loanacctNo === undefined ){
      this.isShow='RecordNotFound';
    this.message="Record Not Found";
    }
      else{
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200') {
        //this.transactionListRespTD=IbResponse;
        this.loanAcct = data.param5;
        this.moduleType = data.param5.moduleType;
        this.fullName = data.param5.fullName;
        this.clrBalanceStr = data.param5.clrBalanceStr;
        this.isShow = 'page2';
        this.showLoanAmount ='Hide';
       // this.timetStart.resetTimer();
      } else if (data !== null && data.status === 'S200') {
        //this.error = response.statusDescription;
      }else{
       // alert(data.param1);
      }
    });
     }
    
  }
  showLoanBalance(){
      if(this.showLoanAcctBalanceButtonName==='hide'){
        this.showLoanAmount='show';
         this.showLoanAcctBalanceButtonName='Show';
      }else{
        this.showLoanAmount='hide';
        this.showLoanAcctBalanceButtonName='Hide';
      }
  }

  ngOnInit() {
   }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/loan-account/loan-account.component.ts